import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

// Login Redux States
import { LOGIN_USER, LOGOUT_USER, SOCIAL_LOGIN } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess } from "./actions";

//Include Both Helper File with needed methods
import { getFirebaseBackend } from "helpers/firebase_helper";
import {
  postFakeLogin,
  postJwtLogin,
  postSocialLogin,
} from "helpers/fakebackend_helper";

import {
  postLogin,
} from "helpers/backend_api_helper";

const fireBaseBackend = getFirebaseBackend();

function* loginUser({ payload: { user, callback } }) {
  try {
    const response = yield call(postLogin, user);
    if(response?.status_code == '200'){
      sessionStorage.setItem("authUser", JSON.stringify(response));

    }
    callback && callback(response);
    yield put(loginSuccess(response));

  } catch (error) {
    yield put(apiError(error?.response?.data?.message || "Server Error"));
  }
}

// function* loginUser({ payload: { user, callback } }) {
//   try {
//     const response = yield call(postLogin, user);

//     if (response?.status_code === '200') {
      
//       // Save login session only for current browser tab
//       sessionStorage.setItem("authUser", JSON.stringify(response));

//     }

//     callback && callback(response);
//     yield put(loginSuccess(response));

//   } catch (error) {
//     yield put(apiError(error?.response?.data?.message || "Server Error"));
//   }
// }



function* logoutUser({ payload: { history } }) {
  try {
    sessionStorage.removeItem("authUser");
    sessionStorage.removeItem("number");

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call(fireBaseBackend.logout);
      yield put(logoutUserSuccess(response));
    }
    history('/');
  } catch (error) {
    yield put(apiError(error));
  }
}


function* socialLogin({ payload: { data, history, type } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend = getFirebaseBackend();
      const response = yield call(
        fireBaseBackend.socialLoginUser,
        data,
        type,
      );
      sessionStorage.setItem("authUser", JSON.stringify(response));
      yield put(loginSuccess(response));
    } else {
      const response = yield call(postSocialLogin, data);
      sessionStorage.setItem("authUser", JSON.stringify(response));
      yield put(loginSuccess(response));
    }
    history("/dashboard");
  } catch (error) {
    yield put(apiError(error));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeLatest(SOCIAL_LOGIN, socialLogin);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
